import { PatientRawResponses } from "~/providers/components";

export const OngoingPatientRawResponses = () => <PatientRawResponses />;
